/**
 * Mini Cart Price Mover
 * Moves price containers into title/variant/discount/error containers
 */

(function() {
  'use strict';

  // Function to move price containers
  function movePriceContainers() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    let movedCount = 0;
    
    products.forEach(product => {
      const priceContainer = product.querySelector('.fcsb-price-container');
      const titleContainer = product.querySelector('.fcsb-title-variant-discount-error');
      
      if (priceContainer && titleContainer) {
        // Check if price container is not already inside title container
        if (!titleContainer.contains(priceContainer)) {
          titleContainer.appendChild(priceContainer);
          movedCount++;
        }
      }
    });
    
    if (movedCount > 0) {
      // Price containers moved successfully
    }
  }

  // Function to remove parentheses from quantity elements
  function removeQuantityParentheses() {
    const quantityElements = document.querySelectorAll('.fcsb-quantity');
    let cleanedCount = 0;

    quantityElements.forEach(element => {
      const originalText = element.textContent;
      const cleanedText = originalText.replace(/[()]/g, '');
      
      if (originalText !== cleanedText) {
        element.textContent = cleanedText;
        cleanedCount++;
      }
    });

    if (cleanedCount > 0) {
      // Quantity elements cleaned successfully
    }
  }

  // Function to add shopping cart icon to title elements (scoped to mini cart)
  function addCartIcons() {
    const miniCartTitle = document.querySelector('.fcsb-mini-cart-title');
    if (!miniCartTitle) return;
    
    const titleElements = miniCartTitle.querySelectorAll('.fcsb-title');
    let iconsAdded = 0;

    titleElements.forEach(element => {
      // Check if icon already exists
      if (!element.querySelector('.cart-title-icon')) {
        const iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-shopping-cart w-5 h-5 text-[#C70751] cart-title-icon"><circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle><path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path></svg>`;
        element.insertAdjacentHTML('afterbegin', iconSvg);
        iconsAdded++;
      }
    });

    if (iconsAdded > 0) {
      // Cart icons added successfully
    }
  }

  // Function to replace close button content with icon (scoped to mini cart)
  function addCloseIcons() {
    const miniCartTitle = document.querySelector('.fcsb-mini-cart-title');
    if (!miniCartTitle) return;
    
    const closeButtons = miniCartTitle.querySelectorAll('.fcsb-close-button');
    let iconsAdded = 0;

    closeButtons.forEach(element => {
      // Check if content hasn't been replaced yet
      if (!element.querySelector('.close-button-icon')) {
        const iconSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x h-4 w-4 close-button-icon"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>`;
        element.innerHTML = iconSvg;
        iconsAdded++;
      }
    });

    if (iconsAdded > 0) {
      // Close button contents replaced successfully
    }
  }

  function parseMoneyString(value) {
    if (!value)
      return NaN;

    const normalized = value.replace(/[^\d.,-]/g, '').trim();
    if (!normalized)
      return NaN;

    const lastComma = normalized.lastIndexOf(',');
    const lastDot = normalized.lastIndexOf('.');
    const hasComma = lastComma !== -1;
    const hasDot = lastDot !== -1;

    if (hasComma && hasDot) {
      if (lastDot > lastComma)
        return parseFloat(normalized.replace(/,/g, ''));
      return parseFloat(normalized.replace(/\./g, '').replace(',', '.'));
    }

    if (hasComma && !hasDot) {
      if ((normalized.match(/,/g) || []).length === 1)
        return parseFloat(normalized.replace(',', '.'));
      return parseFloat(normalized.replace(/,/g, ''));
    }

    return parseFloat(normalized);
  }

  function parsePriceValue(element) {
    if (!element)
      return NaN;

    const textValue = parseMoneyString(element.textContent || '');
    if (!Number.isNaN(textValue))
      return textValue;

    if (element.innerHTML) {
      const htmlStripped = element.innerHTML.replace(/<[^>]*>/g, '');
      const htmlValue = parseMoneyString(htmlStripped);
      if (!Number.isNaN(htmlValue))
        return htmlValue;
    }

    if (element.dataset) {
      const datasetCandidates = [
        element.dataset.price,
        element.dataset.value,
        element.dataset.amount
      ];
      for (const candidate of datasetCandidates) {
        if (!candidate)
          continue;
        const cleaned = candidate.replace(/[^\d.-]/g, '');
        if (!cleaned)
          continue;
        const numeric = Number(cleaned);
        if (Number.isNaN(numeric))
          continue;
        if (!candidate.includes('.') && !candidate.includes(','))
          return numeric / 100;
        return numeric;
      }
    }

    return NaN;
  }

  function extractCurrencySymbol(element) {
    if (!element)
      return '$';
    const matches = (element.textContent || '').match(/[^0-9.,\s-]+/g);
    if (!matches || !matches.length)
      return '$';
    return matches[matches.length - 1];
  }

  // Function to calculate and display savings
  function addSavingsDisplay() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    products.forEach(product => {
      const priceContainer = product.querySelector('.fcsb-price-container');
      if (!priceContainer) return;

      const currentPrice = priceContainer.querySelector('.fcsb-price');
      const originalPrice = priceContainer.querySelector('.fcsb-original-price');

      const existingSavings = product.querySelector('.savings-display');

      if (currentPrice && originalPrice) {
        const currentPriceValue = parsePriceValue(currentPrice);
        const originalPriceValue = parsePriceValue(originalPrice);

        if (!Number.isNaN(currentPriceValue) && !Number.isNaN(originalPriceValue) && originalPriceValue > currentPriceValue) {
          const savings = originalPriceValue - currentPriceValue;
          const percentOff = Math.round((savings / originalPriceValue) * 100);
          const currencySymbol = extractCurrencySymbol(currentPrice);
          const currencySpacing = currencySymbol.length > 1 ? ' ' : '';

          let savingsElement = existingSavings;
          if (!savingsElement) {
            savingsElement = document.createElement('div');
            savingsElement.className = 'savings-display';
            savingsElement.style.fontSize = '12px';
            savingsElement.style.color = '#16a34a';
            savingsElement.style.fontWeight = '500';
            savingsElement.style.marginTop = '4px';
          }

          savingsElement.textContent = `Save ${percentOff}% Off`;

          if (priceContainer.nextElementSibling !== savingsElement)
            priceContainer.insertAdjacentElement('afterend', savingsElement);
          return;
        }
      }

      if (existingSavings)
        existingSavings.remove();
    });
  }

  // Function to hide bundled installation line items in FCSB cart
  function hideInstallationItems() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    products.forEach(product => {
      // Find ALL links and text in this product row
      const allLinks = product.querySelectorAll('a[href]');
      const allText = (product.textContent || '').toLowerCase();

      let isInstallProduct = false;

      // Check links for installation product URL
      allLinks.forEach(link => {
        const href = (link.getAttribute('href') || '').toLowerCase();
        if (href.includes('installation-package-outdoor-kitchen')) {
          isInstallProduct = true;
        }
      });

      // Also check by exact title match as fallback
      if (!isInstallProduct && allText.includes('installation package - outdoor kitchen')) {
        isInstallProduct = true;
      }

      if (isInstallProduct) {
        const row = product.closest('.fcsb-mini-cart-product-container') || product;
        row.style.display = 'none';
      }
    });
  }

  // Function to add install note to outdoor kitchen items in FCSB cart
  function addInstallNoteToKitchen() {
    const products = document.querySelectorAll('.fcsb-mini-cart-product-container-grid');
    products.forEach(product => {
      // Skip if already has install note
      if (product.querySelector('.fcsb-install-note')) return;

      // Skip if this is the hidden installation product
      const allText = (product.textContent || '').toLowerCase();
      if (allText.includes('installation package - outdoor kitchen')) return;

      // Check links for the Zurich or other outdoor kitchen products
      const allLinks = product.querySelectorAll('a[href]');
      let isKitchenProduct = false;

      allLinks.forEach(link => {
        const href = (link.getAttribute('href') || '').toLowerCase();
        if (href.includes('euro-alfresco')) {
          isKitchenProduct = true;
        }
      });

      if (!isKitchenProduct) return;

      const titleContainer = product.querySelector('.fcsb-title-variant-discount-error') || product.querySelector('.fcsb-title');
      if (!titleContainer) return;

      const note = document.createElement('div');
      note.className = 'fcsb-install-note';
      note.style.cssText = 'display:inline-flex;align-items:center;gap:4px;color:#0D9488;font-size:12px;font-weight:500;margin-top:4px;';
      note.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg> Incl. Check, Measure &amp; Assembly ($1,450)';
      titleContainer.appendChild(note);
    });
  }

  // NOTE: the old syncInstallationWithKitchen() poller lived here. It acted on a
  // /cart.js snapshot that could be seconds stale, so if a kitchen was removed and
  // re-added it could delete the assembly line the re-add had just merged into.
  // syncAssemblyQuantity() (below) now owns add/remove/quantity of the assembly.

  // Helper: fetch /cart.js with retry-on-429 backoff. Returns cart object or null on
  // permanent failure. Doesn't throw on parse errors when Shopify returns its HTML
  // rate-limit page.
  function fetchCartJsonWithBackoff(attempt) {
    return fetch('/cart.js')
      .then(function (r) {
        if (r.status === 429) {
          if (attempt >= 2) return null; // give up after 3 attempts
          var delay = 1500 * Math.pow(2, attempt); // 1.5s, 3s, 6s
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(fetchCartJsonWithBackoff(attempt + 1));
            }, delay);
          });
        }
        return r.json().catch(function () { return null; });
      })
      .catch(function () { return null; });
  }

  // Function to update empty cart content
  function updateEmptyCartContent() {
    const emptyCartElement = document.querySelector('.fcsb-mini-cart-empty');
    if (!emptyCartElement) return;

    // Check if we already updated the content
    if (emptyCartElement.querySelector('.custom-empty-cart')) return;

    const newContent = `
      <div class="custom-empty-cart">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="8" cy="21" r="1"></circle><circle cx="19" cy="21" r="1"></circle>
          <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"></path>
        </svg>
        <h4>Your cart is empty</h4>
        <p>Add some products to get started.</p>
      </div>
    `;

    emptyCartElement.innerHTML = newContent;
  }

  // Initialize when DOM is ready
  var initAttempts = 0;
  var MAX_INIT_ATTEMPTS = 10;

  function init() {
    const runEnhancements = () => {
      movePriceContainers();
      removeQuantityParentheses();
      addCartIcons();
      addCloseIcons();
      addSavingsDisplay();
      hideInstallationItems();
      addInstallNoteToKitchen();
      updateEmptyCartContent();
      initCheckoutButton();
    };

    let enhancementScheduled = false;
    const scheduleEnhancements = (delay = 0) => {
      if (enhancementScheduled)
        return;
      enhancementScheduled = true;

      const execute = () => {
        enhancementScheduled = false;
        runEnhancements();
      };

      if (delay > 0) {
        setTimeout(execute, delay);
      } else if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(execute);
      } else {
        setTimeout(execute, 16);
      }
    };

    runEnhancements();
    scheduleEnhancements(2000);

    const miniCartSidebar = document.querySelector('.fcsb-mini-cart-sidebar');
    
    if (miniCartSidebar) {
      const observer = new MutationObserver(() => {
        scheduleEnhancements();
      });

      observer.observe(miniCartSidebar, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });

      document.addEventListener('fcsb:cart:updated', scheduleEnhancements);
      document.addEventListener('fcsb:cart:item-removed', scheduleEnhancements);
      document.addEventListener('fcsb:cart:quantity-changed', scheduleEnhancements);
    } else if (++initAttempts < MAX_INIT_ATTEMPTS) {
      // Retry after a delay if mini cart isn't loaded yet. Capped: the Cartylabs
      // (fcsb) app embed is disabled, so its sidebar may never appear.
      setTimeout(init, 1000);
    }

    window.__scheduleMiniCartEnhancements = scheduleEnhancements;
  }

  // Function to handle checkout button click
  function initCheckoutButton() {
    const checkoutButton = document.querySelector('.fcsb-checkout');
    if (!checkoutButton) return;

    // Avoid adding multiple listeners
    if (checkoutButton.dataset.listenerAdded) return;
    checkoutButton.dataset.listenerAdded = 'true';

    checkoutButton.addEventListener('click', function() {
      const span = this.querySelector('span');
      const originalText = span ? span.textContent : 'Go To Checkout';
      const originalBg = this.style.backgroundColor;

      // Change to loading state
      this.style.backgroundColor = '#15803d';
      if (span) {
        span.textContent = 'Please wait...';
      }

      // Reset after 5 seconds
      setTimeout(() => {
        this.style.backgroundColor = originalBg || '';
        if (span) {
          span.textContent = originalText;
        }
      }, 5000);
    });
  }

  // ---------------------------------------------------------------------------
  // Fast assembly removal (native Horizon cart drawer)
  // When a kitchen line's Remove is clicked, delete the kitchen AND its hidden
  // assembly line in the SAME /cart/update.js call, then re-render — so the
  // assembly never lingers.
  // Uses window-capture so it runs before the theme's document-capture handler.
  // ---------------------------------------------------------------------------
  var fastRemovalWired = false;

  function getNativeCartSectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      var id = el.getAttribute('data-section-id');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function initFastAssemblyRemoval() {
    if (fastRemovalWired) return;
    fastRemovalWired = true;

    window.addEventListener('click', function (e) {
      var removeBtn = e.target.closest && e.target.closest('.cart-item-card__remove, .cart-items__remove');
      if (!removeBtn) return;
      var row = removeBtn.closest('[data-key]');
      // Only intercept install-required kitchen lines; let the theme handle the rest.
      if (!row || !row.querySelector('.cart-item-card__install-note')) return;

      e.preventDefault();
      e.stopImmediatePropagation();

      // Remove this kitchen's own installation (per-model or default) with it. If
      // another kitchen still uses that installation, the assembly sync re-adds it.
      var installId = getKitchenInstallVariantId(row);
      var updates = {};
      updates[row.getAttribute('data-key')] = 0;
      document.querySelectorAll('.cart-items__install-bundle[data-key]').forEach(function (bundleRow) {
        var bundleId = bundleRow.getAttribute('data-install-variant-id');
        if (!bundleId || !installId || bundleId === installId) updates[bundleRow.getAttribute('data-key')] = 0;
      });

      var sectionIds = getNativeCartSectionIds();
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: sectionIds.join(','),
          sections_url: window.location.pathname
        })
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          // Native re-render: cart-items-component morphs from detail.data.sections,
          // cart-icon reads itemCount.
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: {
              resource: cart,
              sourceId: 'assembly-fast-remove',
              data: { source: 'assembly-fast-remove', itemCount: cart.item_count, sections: cart.sections }
            }
          }));
        })
        .catch(function (err) { console.warn('[AssemblyFastRemove] failed:', err); });
    }, true);

    console.log('[AssemblyFastRemove] Ready (native cart)');
  }

  initFastAssemblyRemoval();

  // ---------------------------------------------------------------------------
  // Assembly sync (native Horizon cart drawer)
  // The assembly is a separate line item that must mirror the kitchen quantity —
  // one assembly per kitchen, so 2 kitchens => 2 assemblies charged. Each kitchen
  // uses its own installation product when it has an "install-package:" tag
  // (e.g. Installation Package - Outdoor Kitchen Dublin), otherwise the default
  // Installation Package - Outdoor Kitchen. On any cart change we reconcile each
  // installation variant: add it if a kitchen is in the cart without one, re-sync
  // its quantity, or remove it when no kitchen needs it. This makes the cart
  // self-healing however the kitchen got there (re-added after a remove, wishlist
  // "move to cart", a failed/raced bundle add, an old saved cart).
  // ---------------------------------------------------------------------------
  // Prefix: also matches per-model packages such as installation-package-outdoor-kitchen-dublin.
  var ASSEMBLY_HANDLE = 'installation-package-outdoor-kitchen';
  var assemblySyncing = false;
  var assemblySyncPending = false;

  /** Default installation variant (theme setting, output in layout/theme.liquid). */
  function getInstallVariantId() {
    return window.CB_INSTALL_VARIANT_ID ? String(window.CB_INSTALL_VARIANT_ID) : '';
  }

  /** Installation variant for a kitchen row: its per-model package, else the default. */
  function getKitchenInstallVariantId(row) {
    var note = row && row.querySelector('.cart-item-card__install-note');
    return (note && note.getAttribute('data-install-variant-id')) || getInstallVariantId();
  }

  function isAssemblyItem(item) {
    var defaultId = getInstallVariantId();
    return (item.handle && item.handle.indexOf(ASSEMBLY_HANDLE) === 0) ||
      (defaultId !== '' && String(item.variant_id) === defaultId);
  }

  /**
   * Install-required kitchens, read from the rendered cart markup
   * (snippets/cart-products.liquid adds .cart-item-card__install-note to lines
   * whose product has the "install-required" tag — /cart.js has no tags).
   * Prefers freshly rendered sections from the event; falls back to the live DOM.
   * Returns { kitchens: {lineKey: installVariantId}, rendered: {lineKey: true} },
   * or null if no rendered cart is available, so we never act on a guess.
   */
  function getKitchenLineKeys(sections) {
    var roots = [];
    if (sections) {
      for (var id in sections) {
        if (!Object.prototype.hasOwnProperty.call(sections, id) || !sections[id]) continue;
        try { roots.push(new DOMParser().parseFromString(sections[id], 'text/html')); } catch (e) { /* ignore */ }
      }
    }
    roots = roots.filter(function (root) { return root.querySelector('cart-items-component'); });
    if (!roots.length && document.querySelector('cart-items-component')) roots = [document];
    if (!roots.length) return null;

    var kitchens = {};
    var rendered = {};
    roots.forEach(function (root) {
      root.querySelectorAll('[data-key]').forEach(function (row) {
        var key = row.getAttribute('data-key');
        rendered[key] = true;
        if (row.querySelector('.cart-item-card__install-note')) kitchens[key] = getKitchenInstallVariantId(row);
      });
    });
    return { kitchens: kitchens, rendered: rendered };
  }

  function parseItemCountFromSections(sections) {
    if (!sections) return null;
    for (var id in sections) {
      if (!Object.prototype.hasOwnProperty.call(sections, id) || !sections[id]) continue;
      try {
        var el = new DOMParser().parseFromString(sections[id], 'text/html').querySelector('[ref="cartItemCount"]');
        if (el) return parseInt(el.textContent, 10);
      } catch (e) { /* ignore */ }
    }
    return null;
  }

  function dispatchAssemblySync(resource, itemCount, sections) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: resource || {},
        sourceId: 'assembly-sync',
        data: { source: 'assembly-sync', itemCount: itemCount, sections: sections }
      }
    }));
  }

  async function syncAssemblyQuantity(sections) {
    // A cart change mid-sync is re-checked afterwards rather than dropped.
    if (assemblySyncing) { assemblySyncPending = true; return; }
    // Claimed before the first await, so two syncs started together (page load +
    // cart:update) cannot both read the same cart and both add an assembly.
    assemblySyncing = true;
    try {
      await reconcileAssembly(sections);
    } catch (e) {
      console.warn('[AssemblySync] failed:', e);
    } finally {
      assemblySyncing = false;
      if (assemblySyncPending) {
        assemblySyncPending = false;
        syncAssemblyQuantity();
      }
    }
  }

  async function reconcileAssembly(sections) {
    var cart = await fetchCartJsonWithBackoff(0);
    if (!cart || !cart.items) return;

    var lineKeys = getKitchenLineKeys(sections);
    if (!lineKeys) return;
    // Markup not yet re-rendered for this cart (a line is missing) — don't act on it.
    var stale = cart.items.some(function (item) {
      return !isAssemblyItem(item) && !lineKeys.rendered[item.key];
    });
    if (stale) return;

    // Kitchen quantity needed per installation variant, and the assembly lines present.
    var needed = {};
    var assemblies = {};
    cart.items.forEach(function (item) {
      if (isAssemblyItem(item)) {
        var vid = String(item.variant_id);
        (assemblies[vid] = assemblies[vid] || []).push(item);
      } else if (Object.prototype.hasOwnProperty.call(lineKeys.kitchens, item.key)) {
        var installId = lineKeys.kitchens[item.key];
        if (!installId) {
          console.warn('[AssemblySync] Kitchen in cart without assembly, but no install variant id configured.');
          return;
        }
        needed[installId] = (needed[installId] || 0) + item.quantity;
      }
    });

    // One line per installation variant at the needed quantity; extra lines go to 0.
    var updates = {};
    var additions = [];
    var vids = Object.keys(needed);
    Object.keys(assemblies).forEach(function (vid) { if (vids.indexOf(vid) === -1) vids.push(vid); });
    vids.forEach(function (vid) {
      var qty = needed[vid] || 0;
      var lines = assemblies[vid] || [];
      if (!lines.length) {
        // Kitchen without assembly: add it back (same properties as installation-bundle.js).
        additions.push({
          id: parseInt(vid, 10),
          quantity: qty,
          properties: { '_bundled_with': 'Outdoor Kitchen Package', '_type': 'Assembly' }
        });
        return;
      }
      lines.forEach(function (line, i) {
        var want = i === 0 ? qty : 0;
        if (line.quantity !== want) updates[line.key] = want;
      });
    });
    if (!additions.length && !Object.keys(updates).length) return; // already in sync

    var sectionIds = getNativeCartSectionIds().join(',');
    var resp, updated;
    if (Object.keys(updates).length) {
      // quantity 0 also removes an orphaned assembly (e.g. kitchen stepped to 0).
      resp = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: updates,
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      });
      updated = resp.ok ? await resp.json() : null;
      if (!resp.ok) console.warn('[AssemblySync] cart request failed:', resp.status);
      else if (!additions.length) dispatchAssemblySync(updated, updated.item_count, updated.sections);
      console.log('[AssemblySync] assembly quantities ->', updates);
    }
    if (additions.length) {
      resp = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: additions,
          sections: sectionIds,
          sections_url: window.location.pathname
        })
      });
      updated = resp.ok ? await resp.json() : null;
      if (!resp.ok) console.warn('[AssemblySync] cart request failed:', resp.status);
      else dispatchAssemblySync({}, parseItemCountFromSections(updated.sections), updated.sections);
      console.log('[AssemblySync] assembly re-added:', additions.map(function (a) { return a.id + ' x' + a.quantity; }).join(', '));
    }
  }

  // Run on every cart change except our own sync (avoids loops). Bundle adds and
  // fast removals are re-checked too, so a merged/duplicated assembly gets corrected.
  document.addEventListener('cart:update', function (e) {
    var data = e && e.detail && e.detail.data;
    if (data && data.source === 'assembly-sync') return;
    syncAssemblyQuantity(data && data.sections);
  });

  // Also reconcile once on page load if the rendered cart holds a kitchen or an
  // assembly, so carts already missing the assembly are repaired before checkout.
  function syncAssemblyOnLoad() {
    if (document.querySelector('.cart-item-card__install-note, .cart-items__install-bundle')) {
      syncAssemblyQuantity();
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAssemblyOnLoad);
  } else {
    syncAssemblyOnLoad();
  }

  // Global functions for manual triggering
  window.moveMiniCartPrices = movePriceContainers;
  window.removeQuantityParentheses = removeQuantityParentheses;
  window.addCartIcons = addCartIcons;
  window.addCloseIcons = addCloseIcons;
  window.addSavingsDisplay = addSavingsDisplay;
  window.updateEmptyCartContent = updateEmptyCartContent;
  window.initCheckoutButton = initCheckoutButton;

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
